// src/pages/NotFound.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Package } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="mb-8">
          <Package className="w-24 h-24 text-gray-300 mx-auto mb-4" />
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Page non trouvée
        </h2>

        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </button>

          <button
            onClick={() => navigate('/driver')}
            className="btn btn-primary flex items-center gap-2"
          >
            <Home className="w-4 h-4" />
            Tableau de bord
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;